<template>
    <transition name="modal">
        <div class="modal">
            <button class="close_modal" @click="closeComponent">
                <img src="@/assets/svg/icon_close_b.svg" alt="icon_close_b">
            </button>
        </div>
    </transition>
</template>

<script>
  export default {
    props: ['value'],
    data() {
      return {
        component: ''
      }
    },
    methods: {
      closeComponent: function () {
        this.component = null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/home-page-components/Feedback.vue